export function createSingleton(instance) {
    if (!window.tdocsNetcheck) {
        // 如果 window 上没有全局 DocsNetcheck, 则初始化单例
        window.tdocsNetcheck = instance;
        window.tdocsNetcheck.init();
    }
    else {
        // 新版本覆盖旧版本,并且继承原有的回调函数
        const version = window.tdocsNetcheck.getVersion();
        if (instance.getVersion() > version) {
            instance.extendCallbacks(window.tdocsNetcheck.getCallbacks());
            window.tdocsNetcheck.destory();
            window.tdocsNetcheck = instance;
            window.tdocsNetcheck.init();
        }
    }
    // window 上的tdocsNetcheck是全局单例,最终以这个为准;
    return window.tdocsNetcheck;
}
// Promise.any polyfill
export const promiseAny = (promises) => new Promise((resolve, reject) => {
    let { length } = promises;
    if (!length)
        reject(new AggregateError('null'));
    const errors = [];
    promises.forEach((promise) => {
        promise
            .then(value => resolve(value))
            .catch((error) => {
            length -= 1;
            errors.push(error);
            if (!length)
                reject(new AggregateError(errors));
        });
    });
});
//# sourceMappingURL=helper.js.map